import { gql } from '@apollo/client'

export const deleteUserAccountMutation = gql`
  mutation deleteUserAccount($userId: String!) {
    deleteUserAccount(userId: $userId)
  }
`
